import { cartReducer } from 'app/state/cart-state'
import { combineReducers, composeReducers } from '@ynap/reducer-utils'
import { reducer as form } from 'redux-form'
import { connectRouter } from 'connected-react-router'
import { authReducer } from '@ynap/auth-state'
import { countryReducer } from '@ynap/country-state'

export default (history) => composeReducers(combineReducers({ form, router: connectRouter(history) }), authReducer, cartReducer, countryReducer)
